import * as React from 'react';
import { BurgerMenu, FixedInnerCol, MenuCol } from './SideMenu.style';
import MenuList from './MenuList/MenuListContainer';
import TakeTour from './TakeTour/TakeTourContainer';

export const SideMenuComponent = ({
  isLoggedIn,
  large,
  location: { pathname },
  match: { url }
}) =>
  isLoggedIn &&
  (large ? (
    <MenuCol>
      <FixedInnerCol>
        <MenuList pathname={pathname} url={url} />
        <TakeTour />
      </FixedInnerCol>
    </MenuCol>
  ) : (
    <BurgerMenu>
      <MenuList pathname={pathname} url={url} />
    </BurgerMenu>
  ));

export default SideMenuComponent;



// WEBPACK FOOTER //
// ./src/components/common/SideMenu/SideMenuComponent.js